module.exports = __webpack_public_path__ + "static/media/CS97.1e392940.PNG";